/*
 * Copyright 2022-2025 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, OnInit } from "@angular/core";
import { MerchantSearchSummary } from "../../models";
import { AuthService, MerchantService, NotificationService } from "../../services";
import { FormControl, FormGroup, Validators, ValidatorFn, ValidationErrors, AbstractControl } from "@angular/forms";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html"
})
export class SearchComponent implements OnInit {
  constructor(
    private merchantService: MerchantService,
    private notificationService: NotificationService,
    public authService: AuthService
  ) {}

  merchantSearch!: FormGroup;
  merchantList: MerchantSearchSummary[] = [];
  searchInProgress = false;
  downloadFullMerchantListInProgress = false;
  hasFinanceRole = true;

  ngOnInit(): void {
    this.merchantSearch = new FormGroup({
      searchInput: new FormControl("", [Validators.required, this.minPrunedLength(2)])
    });
    this.hasFinanceRole = this.authService.canUserAccess("FINANCE");
  }

  runMerchantSearch(): void {
    this.searchInProgress = true;
    this.merchantService.searchMerchants(this.merchantSearch.getRawValue().searchInput).subscribe(
      (merchantList) => {
        this.merchantList = merchantList;
        this.searchInProgress = false;
      },
      (error) => {
        this.notificationService.error(error.error);
        this.searchInProgress = false;
      }
    );
  }

  downloadFullMerchantList(): void {
    if (!this.downloadFullMerchantListInProgress) {
      this.downloadFullMerchantListInProgress = true;
      this.merchantService.downloadFullMerchantList().subscribe(
        (file) => {
          this.downloadFullMerchantListInProgress = false;
          const link = document.createElement("a");
          link.setAttribute("href", URL.createObjectURL(file.body));
          link.setAttribute("download", SearchComponent.parseFileName(file) + ".csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        (error) => {
          this.downloadFullMerchantListInProgress = false;
          this.notificationService.error(error.error);
        }
      );
    }
  }

  private static parseFileName(response: any) {
    let filename = "";
    const disposition = response.headers.get("content-disposition");
    if (disposition) {
      filename = disposition.split(";")[1].trim().split("=")[1];
    }
    return filename;
  }
  private minPrunedLength(length: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const prunedValueLength = control.value.replaceAll(" ", "").length;
      return prunedValueLength < length ? { forbiddenName: { value: control.value } } : null;
    };
  }
}
